import { StyleSheet, Text, View } from "react-native";
import React from "react";

const Shop = () => {
  return (
    <View>
      <Text>Shop</Text>
    </View>
  );
};

export default Shop;

const styles = StyleSheet.create({});
